export default {"src":"/_next/static/image/src/images/account/icon-video-call.5461c65e94b29fb334615c104933e57b.svg","height":96,"width":96};